var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuestionMultichoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.02715 7.25599L1.07715 4.30599L2.25215 3.13099L4.01915 4.89799L7.55215 1.36499L8.72715 2.53999L4.02715 7.25699V7.25599Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.02715 14.256L1.07715 11.306L2.25215 10.131L4.01915 11.898L7.55215 8.36499L8.72715 9.53999L4.02715 14.257V14.256Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.02715 21.256L1.07715 18.306L2.25215 17.131L4.01915 18.898L7.55215 15.365L8.72715 16.54L4.02715 21.256Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 5.99999V3.99999H22.0001V5.99999H10.0001Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 13V11H22.0001V13H10.0001Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 20V18H22.0001V20H10.0001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionMultichoice);
export default __webpack_public_path__ + "static/media/icon-question-multichoice.410413f1a3e2771769e845dc5b927cc0.svg";
export { ForwardRef as ReactComponent };